import React, { forwardRef, useState, useEffect } from "react";
import { List } from "colbi_web_ui/lib/components";
import styles from "./OrganizationDataForm.module.sass";
import ExportButton from "../../../components/ExportButton/ExportButton";
import { datetime } from "../../../utils";
import { EntityCard } from "colbi_web_ui/lib/components/rows";
import { SovosIcon } from "mosaic-react";
import { SummarizeOutlined } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const OrganizationDataForm = (props, ref) => {
    const { organization_requests, listProps } = props;

    //prevent form to have undefined props
    const [tempListProps, setTempListProps] = useState(listProps);
    const { i18n } = useGlobalValue();

    useEffect(() => {
        try {
            if (!tempListProps && listProps) {
                setTempListProps(listProps);
            }
        } catch (e) {
            alert("invalid parameter");
        }
    }, [tempListProps, listProps]);

    const organizationRequestsContent =
        organization_requests && (organization_requests.organizationRequests || []);

    const items = (organizationRequestsContent || []).map((elem) => {
        const { fiscalYear, organizationId, startedAt, status, pathsToDownload } = elem;
        return {
            card: [
                [
                    {
                        labels: ["fiscalYear"],
                        value: fiscalYear,
                        type: "string",
                        style: "bold",
                        align: "center",
                        basis: "10%",
                    },
                ],
                [
                    {
                        labels: ["requestData"],
                        value: (
                            <div
                                className={styles["actions-user-buttons"]}
                                onClick={() => {
                                    tempListProps.handleRequestDataForOrganizations &&
                                        tempListProps.handleRequestDataForOrganizations(
                                            tempListProps,
                                            fiscalYear,
                                        );
                                }}
                            >
                                <SovosIcon>
                                    <SummarizeOutlined style={{ fill: "#015FFF" }} />
                                </SovosIcon>
                            </div>
                        ),
                        type: "number",
                        align: "center",
                    },
                ],
                [
                    {
                        labels: ["startedAt"],
                        value: startedAt ? datetime(startedAt) : "-",
                        type: "date",
                        align: "center",
                    },
                ],
                [
                    {
                        labels: ["status"],
                        value: i18n && i18n`${status || "-"}`,
                        type: "string",
                        align: "center",
                    },
                ],
                [
                    {
                        labels: ["download"],
                        value:
                            status === "done" ? (
                                <ExportButton
                                    data={[elem]}
                                    exportableArray={Object.keys(pathsToDownload || {})}
                                    alternativeQueryData={{
                                        args: {
                                            locale: "en",
                                            organizationId: `${organizationId}`,
                                            fiscalYear: `${fiscalYear}`,
                                            selectedExportableOption: undefined,
                                            page: 0,
                                            pathsToDownload,
                                        },
                                        downloadable: true,
                                        downloadOnly: true,
                                        xlsxTranslation: "entity",
                                    }}
                                />
                            ) : (
                                ""
                            ),
                        type: "string",
                        align: "center",
                    },
                ],
            ],
        };
    });

    return (
        <List
            modifiers={["--row-style-alternate"]}
            header={[
                {
                    label: [`fiscalYear`],
                    columnName: "fiscalYear",
                    align: "center",
                    basis: "15%",
                },
                {
                    label: [`Calculate Report`],
                    columnName: "requestData",
                    align: "center",
                },
                { label: [`Requested At`], columnName: "startedAt", align: "center" },
                { label: [`status`], columnName: "status", align: "center" },
                { label: [`download`], columnName: "download", align: "right" },
            ]}
            items={items}
            card={EntityCard}
        />
    );
};

const OrganizationDataFormRef = forwardRef(OrganizationDataForm);

OrganizationDataFormRef.queries = (args) => {
    return [
        {
            resource: "get_organization_requested_data",
            args: {
                organizationId: args.organizationId,
            },
            body: "organizationRequests{fiscalYear, startedAt, endedAt, status, organizationId, pathsToDownload{calendaryear,fiscalyear}}",
        },
    ].filter((q) => q);
};

OrganizationDataFormRef.dataMapper = ["organization_requests"];

export default OrganizationDataFormRef;
